// extracted by mini-css-extract-plugin
export var menuIcon = "_ub-0";
export var menuIconInline = "_ub-1";